import { useCountriesQuery } from './useCountries';
import { CountryCode } from '../api-types/common';
import { Country } from '../api-types/director';

/**
 * Query to get country data for specified countryCode.
 */
export function useCountry(countryCode: CountryCode) {
  return useCountriesQuery<Country | undefined>({
    select: (countries) => countries.find((country) => country.countryCode === countryCode),
  });
}
